var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.667 3.778a.778.778 0 0 0-1.556 0v.778c-.357 0-.668.002-.93.023-.307.025-.613.08-.907.23-.439.225-.796.582-1.02 1.02-.15.295-.205.6-.23.908-.013.162-.02.342-.022.54a.386.386 0 0 0 .387.39h13.222c.215 0 .39-.175.387-.39a8.047 8.047 0 0 0-.022-.54c-.025-.307-.08-.613-.23-.907a2.334 2.334 0 0 0-1.02-1.02c-.294-.15-.6-.206-.908-.23a12.17 12.17 0 0 0-.93-.024v-.778a.778.778 0 1 0-1.555 0v.778H7.667v-.778zM17 9.61a.389.389 0 0 0-.389-.389H3.39a.389.389 0 0 0-.389.39v4.151c0 .41 0 .764.024 1.055.025.308.08.614.23.908.224.439.581.796 1.02 1.02.294.15.6.205.908.23.29.024.645.024 1.055.024h7.526c.41 0 .764 0 1.055-.024.308-.025.614-.08.908-.23.439-.224.796-.581 1.02-1.02.15-.294.205-.6.23-.908.024-.291.024-.645.024-1.055V9.611z",
    fill: "#5F6375"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic_calendar.53e0dccba62c388370572ca8101d88da.svg";
export { ForwardRef as ReactComponent };